<template>
  <div class="scroll-page">
    <Fixed :navFixed="navFixed"></Fixed>
    <div class="scroll-titleBox" id="scroll-titleBox">
      <p style="font-size:27px; line-height:200%; margin:0pt 0pt 10pt;text-align: center;"><a
        name="_055-1599121612466"></a><span
        style="font-size:27px; font-weight:bold">移动智能终端生态专委会经费管理办法</span></p>
    </div>
    <div class="scroll-contentBox">
      <h1 class="h1 text-center ">
        移动智能终端生态专委会经费管理办法
      </h1>
      <h2 class="h2 margin-t30 margin-b20 nav-title" id="navContent0">
        第一章 总则
      </h2>
      <p class="p margin-l20 margin-b20">
        第一条 根据《移动智能终端生态专委会经费管理办法》制定本办法。
      </p>
      <p class="p margin-l20 margin-b20">
        第二条 本联盟经费由联盟理事长成员单位、理事单位分担，经费用于支付联盟日常运营费用、市场活动费用及其它联盟相关事务所需费用，具体费用构成和分摊比例请见本办法第三章。
      </p>
      <p class="p margin-l20 margin-b20">
        第三条  经费使用进行预算管理。联盟秘书处于每年一月份编制上年决算和当年预算，交由理事会会议审议通过，如该年度对分摊办法无异议可持续延续。
      </p>
      <p class="p margin-l20 margin-b20">
        第四条  本联盟经费必须用于<a style="color: #0A40DD" href="/home/constitution">《移动智能终端生态专业委员会章程》</a>规定的业务范围和事业的发展，接受联盟理事会监督。
      </p>

      <h2 class="h2 margin-t30 margin-b20 nav-title" id="navContent1">
        第二章 定义
      </h2>
      <p class="p margin-l20 margin-b20">
        第五条  联盟理事会成员：联盟发起单位自动成为理事长单位；理事单位经理事长成员提名，全票通过可成为理事单位会成员。目前联盟会成员由小米科技有限责任公司（简称“小米“）、OPPO广东移动通信有限公司（简称“OPPO”）、深圳荣耀终端股份有限公司（简称“荣耀”）、维沃移动通信有限公司（简称“vivo”）、联想集团有限公司（简称“联想”）、中兴通讯股份有限公司（简称“中兴”）自愿联合发起成立的开放性、非营利性的社会组织。
      </p>
      <p class="p margin-l20 margin-b20">
        第六条  联盟服务器费用：联盟日常运维所需的服务器费用（其中包含但不限于云服务器、负载均衡、S3存储、mysql RDS等）、软件费用、网络服务商费用、CDN费用、流量费用、域名购买及续费等各类费用。
      </p>
      <p class="p margin-l20 margin-b10">
        第七条  联盟开发服务费用：联盟日常运营中所需的产品、视觉设计、研发、运维、运营、客服、市场、商务、项管等人效费用。
      </p>
      <p class="p margin-l20 margin-b10">
        第八条  联盟市场费用：联盟线下沙龙等各项市场活动费用。
      </p>
      <p class="p margin-l20 margin-b10">
        第九条  联盟新媒体费用：联盟自媒体账号注册年审、第三方撰稿、媒体传播、舆情监控等全年新媒体费用。
      </p>
      <p class="p margin-l20 margin-b10">
        第十条  联盟会议费用：联盟组织机构中各工作组用于联盟运营活动及其他费用。
      </p>

      <h2 class="h2 margin-t30 margin-b20 nav-title" id="navContent3">
        第三章 联盟费用构成和分摊
      </h2>
      <p class="p margin-l20 margin-b20">
        第十一条  本联盟经费由联盟服务器费用、开发服务费用、市场费用、新媒体费用、会议费用、商标注册、顾问费及其它联盟相关事务所需费用构成。
      </p>
      <p class="p margin-l20 margin-b10">
        第十二条  经联盟理事会成员单位商讨，联盟服务器费用、开发服务费用、新媒体费用、会议费用、商标注册、及顾问费由理事长成员单位OPPO、vivo、小米、荣耀，理事单位联想以会员费的形式进行收取。
      </p>
      <p class="p margin-l20 margin-b10">
        第十三条  上述联盟费用分摊方式延用至2027年12月31日，如该年度对分摊办法无异议可持续延续。
      </p>

      <h2 class="h2 margin-t30 margin-b20 nav-title" id="navContent4">
        第四章 线下活动
      </h2>
      <p class="p margin-l20 margin-b10">
        第十四条  联盟开发者沙龙由理事会成员单位、理事长单位合力举办，线下活动预算为15-20万元/场，活动规模为150人以上；沙龙活动举办时间以每年1-2场节奏进行。
      </p>

      <h2 class="h2 margin-t30 margin-b20 nav-title" id="navContent5">
        第五章 附则
      </h2>
      <p class="p margin-l20 margin-b10">
        第十五条  理事会成员单位可以根据联盟发展需要，向联盟秘书处提出修订《移动智能终端生态专委会经费管理办法》的建议。修订周期根据需求不定期。
      </p>
      <p class="p margin-l20 margin-b10">
        第十六条  《移动智能终端生态专委会经费管理办法》须由理事会成员单位一致同意后生效执行，修改亦同。
      </p>
      <p class="p margin-l20 margin-b10">
        第十七条  理事会成员单位于每年12月31日重新商议下一年度的预算构成，一致同意后迭代更新《移动智能终端生态专委会经费管理办法》，若成员单位对上一年度费用分摊无异议，该办法可持续顺延。
      </p>
      <p class="p margin-l20 margin-b10">
        第十八条  本办法由联盟理事会负责解释。
      </p>
    </div>
  </div>
</template>

<script>
import Fixed from "@/components/Fixed";
export default {
  components: { Fixed },
  data() {
    return {
      navFixed: [
        {
          name:'第一章 : 总则',
          isActive:0,
          class:'#navContent0',
          child:[]
        },
        {
          name:'第二章 : 定义',
          isActive:null,
          class:'#navContent1',
        },
        {
          name:'第三章 : 联盟费用构成和分摊',
          isActive:null,
          class:'#navContent3',
        },
        {
          name:'第四章 : 线下活动',
          isActive:null,
          class:'#navContent4',
        },
        {
          name:'第五章 : 附则',
          isActive:null,
          class:'#navContent5',
        },
      ]
    };
  },
};
</script>

<style lang="scss" scoped>
.scroll-page {
  height: 100%;
  .scroll-titleBox{ 
    position: fixed;
    top: 64px;
    width: 100%;
    padding-top: 20px;
    border-bottom: 1px solid #dde2e8;
    background: #f8f6f7;
    z-index: 6;
  }
  .scroll-contentBox{
    width:calc(100% - 400px) ;
    border-left: 1px solid #dde2e8;
    padding: 2% 3% 2% 2%;
    margin-left: 300px;
    .a-hover{
      color: #1a53ff;
    }
    .a-hover:hover{
      opacity: 0.7;
    }
  }
}
@media screen and (max-width: 800px) {
    .scroll-page {
      .scroll-titleBox{ 
        position: fixed;
        top: 120px;
        width: 100%;
        padding-top: 20px;
        border-bottom: 1px solid #dde2e8;
        background: #f8f6f7;
        z-index: 6;
      }
      .scroll-contentBox{
        box-sizing:border-box; 
        width:100%;
        padding:120px 8% 2% 5%;
        border-left:0;
        margin-top:100px;
        margin-left:0px;
      }
    }
}

.h1 {
  font-size: 32px;
  font-weight: bold;
}
.h2 {
  font-size: 20px;
  font-weight: bold;
}
.h3 {
  font-size: 18px;
  font-weight: bold;
}
.h4 {
  font-size: 17px;
  font-weight: bold;
}
.h5 {
  font-size: 16px;
  font-weight: bold;
}
.p {
  display: block;
  font-size: 15px;
  line-height: 28px;
}
.p-small {
  display: block;
  font-size: 13px;
  line-height: 24px;
}
.w400 {
  width: 400px;
}
.w600 {
  display: block;
  width: 600px;
}
.w750 {
  display: block;
  width: 750px;
}
.code {
  padding: 20px 40px;
  border: 1px solid #f29d1e;
  background-color: #ffffcc;
}
table {
  border-collapse: collapse;
  th,
  td {
    border: 1px solid #000;
    padding: 10px;
  }
}
ul {
  li {
    list-style: disc;
  }
}
</style>

